import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Spinner from 'common/spinner';

type Props = {
  plan: string;
  isMostPopular: boolean;
  price: string;
};

const useStyles = makeStyles((theme) => ({
  spacer: {
    margin: '16px 0px',
  },
  tagHighlight: {
    borderRadius: '10px 10px 0 0',
    background: theme.palette.primary.main,
    color: 'white',
    width: '100%',
  },
}));

const TableHeaderPlan = ({ plan, isMostPopular, price }: Props) => {
  const classes = useStyles();

  if (!price) {
    return <Spinner />;
  }

  return (
    <div>
      <div
        className={classes.tagHighlight}
        style={{ visibility: !isMostPopular ? 'hidden' : 'visible' }}
      >
        <Typography variant="body1">Most Popular</Typography>
      </div>
      <div className={classes.spacer} />
      <Typography variant="body1">{plan}</Typography>
      <div className={classes.spacer} />
      <Typography variant="h4">{price}/mo</Typography>
      <div className={classes.spacer} />
    </div>
  );
};

export default TableHeaderPlan;
